import { useState, useContext, useEffect } from 'react';
import { NavLink, useSearchParams } from "react-router-dom";

import { AuthContext } from '../../context/AuthContext';
import { NotificationsContext } from '../../context/NotificationsContext';

import db from "../../firebase";
import { doc, updateDoc } from "firebase/firestore";
import { getFullDateTimestamp } from "../../utils/functions";

import Header from "../Header";
import Footer from "../Footer";

export default function Notifications() {

	const { currentUser } = useContext(AuthContext);
	const { notifications } = useContext(NotificationsContext);

	const [loading, setLoading] = useState(true);

	//==================================================================
	// user hides one notification

	const hideNotification = async (i) => {

		//console.log('hide');
		//console.log(i);

		//mark as read

		let data = [...notifications];
		data[i]['hidden'] = true;

		const notificationsRef = doc(db, "notifications", currentUser);
		await updateDoc(notificationsRef, {
			notifications: data,
		});
	}

	useEffect(() => {

		//console.log(notifications);
		if (notifications && notifications.length){
			setLoading(false);
		}

	},[notifications]);

    return (

		 <div className="page page_notifications">

			<Header />

			<main>
				<div className="content">

					<ul className="breadcrumbs">
						<li>
							<a href="/">Home</a>
						</li>
						<li>
							<a href="/">Event</a>
						</li>
						<li>
							<span>Search</span>
						</li>
					</ul>

					<div className="page__title">
						<h1>Notifications</h1>

					</div>

					<section className={notifications === 'not found' ? 'empty' : ''}>

						{notifications && notifications.length > 0 &&
							(notifications === 'not found' ?
								<div>
									You don't have any notifications yet
								</div>
								:
								<div className="notifications-bg">
									<div className="notifications-list">
										{notifications.map((notification, notificationIndex) =>
											notification.text &&
												<div className={
													"notification" + (notification.hidden ? ' hidden' : '')
												} key={notificationIndex}>
													<div className="date">
														{notification.timestamp && getFullDateTimestamp(notification.timestamp.seconds)}
													</div>
													<div className="text">
														{notification.text}
													</div>
													<div>
														{!notification.hidden &&
															<label>
																<input 
																	type="checkbox" 
																	onChange={() => hideNotification(notificationIndex)}
																/>
																<span className="checkbox" aria-hidden="true"></span>
															</label>
														}
													</div>
												</div>

										)}
									</div>
								</div>
							)
						}

					</section>

				</div>
			</main>

			<Footer />
		</div>
    )
}


